"use strict";
/*
 * Created on 16. 9. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Row of Promo Shelfplanning Report (LOG-4249, RFC 151). Represents changes on window item (or related window)
 * that were identified at one time.
 * @author Radek Beran
 */


var ShelfReportRow =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ShelfReportRow, _DomainObject_1$Domai);

  /**
   * @param id unique internal id of row
   * @param promotionId
   * @param promotionExtId
   * @param promotionName
   * @param windowId
   * @param windowName
   * @param windowTypeIdOld
   * @param windowTypeIdNew
   * @param windowTypeChanged
   * @param windowStartDateOld
   * @param windowStartDateNew
   * @param windowEndDateOld
   * @param windowEndDateNew
   * @param windowDateChanged true if window start date or window end date was changed within this change
   * @param productId
   * @param productExtId
   * @param productName
   * @param windowItemId
   * @param cmForecast
   * @param promoVolumeOld
   * @param promoVolumeNew
   * @param promoVolumeChanged
   * @param systemVolumeOld
   * @param systemVolumeNew
   * @param requestSPOld request for secondary placement, old value
   * @param requestSPNew request for secondary placement, new value
   * @param requestSPChanged true if request for secondary placement was changed within this change
   * @param onPictureOld
   * @param onPictureNew
   * @param onPictureChanged
   * @param changeDate date and time of last change that lead to creation of this row
   * @param addedCreated true for initial (zero) row (row was Created or Added for new window item)
   * @param deletedCancelled true if this row represents Deleted/Cancelled window item
   * @param userId
   * @param userName
   * @param userSurname
   */
  function ShelfReportRow(id, // promotion
  promotionId, promotionExtId, promotionName, // window
  windowId, windowName, windowTypeIdOld, windowTypeIdNew, windowTypeChanged, windowStartDateOld, windowStartDateNew, windowEndDateOld, windowEndDateNew, windowDateChanged, // product
  productId, productExtId, productName, // window item
  windowItemId, cmForecast, promoVolumeOld, promoVolumeNew, promoVolumeChanged, systemVolumeOld, systemVolumeNew, requestSPOld, requestSPNew, requestSPChanged, onPictureOld, onPictureNew, onPictureChanged, // row metadata
  changeDate, addedCreated, deletedCancelled, userId, userName, userSurname) {
    var _this;

    _classCallCheck(this, ShelfReportRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShelfReportRow).call(this));
    _this.id = id;
    _this.promotionId = promotionId;
    _this.promotionExtId = promotionExtId;
    _this.promotionName = promotionName;
    _this.windowId = windowId;
    _this.windowName = windowName;
    _this.windowTypeIdOld = windowTypeIdOld;
    _this.windowTypeIdNew = windowTypeIdNew;
    _this.windowTypeChanged = windowTypeChanged;
    _this.windowStartDateOld = windowStartDateOld;
    _this.windowStartDateNew = windowStartDateNew;
    _this.windowEndDateOld = windowEndDateOld;
    _this.windowEndDateNew = windowEndDateNew;
    _this.windowDateChanged = windowDateChanged;
    _this.productId = productId;
    _this.productExtId = productExtId;
    _this.productName = productName;
    _this.windowItemId = windowItemId;
    _this.cmForecast = cmForecast;
    _this.promoVolumeOld = promoVolumeOld;
    _this.promoVolumeNew = promoVolumeNew;
    _this.promoVolumeChanged = promoVolumeChanged;
    _this.systemVolumeOld = systemVolumeOld;
    _this.systemVolumeNew = systemVolumeNew;
    _this.requestSPOld = requestSPOld;
    _this.requestSPNew = requestSPNew;
    _this.requestSPChanged = requestSPChanged;
    _this.onPictureOld = onPictureOld;
    _this.onPictureNew = onPictureNew;
    _this.onPictureChanged = onPictureChanged;
    _this.changeDate = changeDate;
    _this.addedCreated = addedCreated;
    _this.deletedCancelled = deletedCancelled;
    _this.userId = userId;
    _this.userName = userName;
    _this.userSurname = userSurname;
    return _this;
  }

  return ShelfReportRow;
}(DomainObject_1.DomainObject);

exports.ShelfReportRow = ShelfReportRow;

ShelfReportRow.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ShelfReportRow.name);
  return {
    id: builder.id('id'),
    // promotion
    promotionId: builder.id('promotionId'),
    promotionExtId: builder.str('promotionExtId'),
    promotionName: builder.str('promotionName'),
    // window
    windowId: builder.id('windowId'),
    windowName: builder.str('windowName'),
    windowTypeIdOld: builder.opt(builder.lookup('windowTypeIdOld', CodebookLookupSequence_1.CodebookLookupSequence.WindowTypes)),
    windowTypeIdNew: builder.opt(builder.lookup('windowTypeIdNew', CodebookLookupSequence_1.CodebookLookupSequence.WindowTypes)),
    windowTypeChanged: builder.bool('windowTypeChanged'),
    windowStartDateOld: builder.opt(builder.date('windowStartDateOld', DateParser_1.DateParser.ISO_PATTERN)),
    windowStartDateNew: builder.opt(builder.date('windowStartDateNew', DateParser_1.DateParser.ISO_PATTERN)),
    windowEndDateOld: builder.opt(builder.date('windowEndDateOld', DateParser_1.DateParser.ISO_PATTERN)),
    windowEndDateNew: builder.opt(builder.date('windowEndDateNew', DateParser_1.DateParser.ISO_PATTERN)),
    windowDateChanged: builder.bool('windowDateChanged'),
    // product
    productId: builder.id('productId'),
    productExtId: builder.str('productExtId'),
    productName: builder.str('productName'),
    // window item
    windowItemId: builder.id('windowItemId'),
    cmForecast: builder.opt(builder.bigNum('cmForecast')),
    promoVolumeOld: builder.opt(builder.bigNum('promoVolumeOld')),
    promoVolumeNew: builder.opt(builder.bigNum('promoVolumeNew')),
    promoVolumeChanged: builder.bool('promoVolumeChanged'),
    systemVolumeOld: builder.opt(builder.bigNum('systemVolumeOld')),
    systemVolumeNew: builder.opt(builder.bigNum('systemVolumeNew')),
    requestSPOld: builder.opt(builder.bool('requestSPOld')),
    requestSPNew: builder.opt(builder.bool('requestSPNew')),
    requestSPChanged: builder.bool('requestSPChanged'),
    onPictureOld: builder.opt(builder.bool('onPictureOld')),
    onPictureNew: builder.opt(builder.bool('onPictureNew')),
    onPictureChanged: builder.bool('onPictureChanged'),
    // row metadata
    changeDate: builder.date('changeDate', DateParser_1.DateParser.ISO_PATTERN),
    addedCreated: builder.bool('addedCreated'),
    deletedCancelled: builder.bool('deletedCancelled'),
    userId: builder.opt(builder.id('userId')),
    userName: builder.opt(builder.str('userName')),
    userSurname: builder.opt(builder.str('userSurname'))
  };
}();